import styled from 'styled-components';

const StyledHomePage = styled.main`
    height: 100vh;
    width: 100vw;

`;

export default StyledHomePage;